import { EoFormConfig } from '../../../form/eo-form/eo-form.config';
import { EoFormTableConfig } from '../../eo-form-table/model';

export interface IEoFormGroupListConfig {
  formConfig?: EoFormConfig;
  formTableConfigs?: EoFormTableConfig[];
}

export class EoFormGroupListConfig implements IEoFormGroupListConfig {
  formConfig?: EoFormConfig;
  formTableConfigs?: EoFormTableConfig[];
  isStaticComponent?: boolean;

  constructor(config: IEoFormGroupListConfig) {
    this.formConfig = config.formConfig;
    this.formTableConfigs = config.formTableConfigs;
  }
}
